export const CUSTOM_ENTITY_TYPE_NAMES = {
  EMPLOYEE: 'Employee',
  LOCATION: 'Location'
} as const;

export const DEFAULT_PAGE_SIZE = 100;
